import { styled, Theme } from '@mui/material';

export const sxStyles = {
  sectionTitle: {
    marginBottom: '2rem',
  },
  opportunitiesCardsWrap: (theme: Theme) => ({
    display: 'flex',
    flexWrap: 'wrap',
    gap: '1.5rem',

    [theme.breakpoints.up(1280)]: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    },
  }),
};

export const StyledSectionInner = styled('div')(({ theme }) => ({
  margin: '1rem 0',

  [theme.breakpoints.up('sm')]: {
    margin: '2rem 0 2.75rem',
  },
}));
